export default [
  {
    path: 'approved-scientific-topics',
    name: 'approved-scientific-topics',
    component: () => import('@/views/pages/front/approved-scientific-topics/ApprovedScientificTopics.vue'),
    meta: {
      pageTitle: 'Approved scientific topics',
      breadcrumb: [
        {
          text: 'Approved scientific topics',
          active: true,
        },
      ],
    },
  },
  {
    path: 'topics',
    name: 'topics',
    component: () => import('@/views/pages/front/scientific-topics/ScientificTopics.vue'),
    meta: {
      pageTitle: 'Recommended scientific topics',
      breadcrumb: [
        {
          text: 'Recommended scientific topics',
          active: true,
        },
      ],
    },
  },
]
